import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

type Session = Record<string, string>;

interface HookReturn {
  getSearch(path: string): string | undefined;
  setLocation: VoidFunction;
}

export default function usePageSearchHistory(): HookReturn {
  const session = sessionStorage.getItem('@ultracar-page-searh');
  const location = session ? (JSON.parse(session) as Session) : undefined;

  const history = useHistory();

  const setLocation = useCallback(() => {
    sessionStorage.setItem(
      '@ultracar-page-searh',
      JSON.stringify({
        ...location,
        [history.location.pathname]: history.location.search,
      }),
    );
  }, [history]);

  const getSearch = useCallback(
    (path: string) => (location ? location[path] : ''),
    [location],
  );

  return { getSearch, setLocation };
}
